// ADDED
import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const leaveIncentiveBatchService = {
  getAll: async () => axios.get(`${domain}/api/LeaveIncentiveBatch`, { headers }),
  
  getById: async (id) => axios.get(`${domain}/api/LeaveIncentiveBatch/${id}`, { headers }),

  create: async (payload) => axios.post(`${domain}/api/LeaveIncentiveBatch`, payload, { headers }),

  update: async (id, payload) => axios.put(`${domain}/api/LeaveIncentiveBatch/${id}`, payload, { headers }),

  process: async (id) => axios.post(`${domain}/api/LeaveIncentiveBatch/process/${id}`, {}, { headers }),

  revert: async (id) => axios.post(`${domain}/api/LeaveIncentiveBatch/revert/${id}`, {}, { headers }),
};

export default leaveIncentiveBatchService;